"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderRoutes = void 0;
var GenderRoutes;
(function (GenderRoutes) {
    GenderRoutes["BasePrefix"] = "genders";
    GenderRoutes["ById"] = ":genderId";
    GenderRoutes["All"] = "all";
    GenderRoutes["List"] = "list";
})(GenderRoutes = exports.GenderRoutes || (exports.GenderRoutes = {}));
